import { IntegrationField } from 'api/integrations';

export enum IntegrationFieldType {
  IssueType = 'IssueType',
  Summary = 'Summary',
  Description = 'Description',
  Number = 'Number',
  Text = 'Text',
  SingleSelect = 'SingleSelect',
  MultiSelect = 'MultiSelect',
  TextArea = 'TextArea',
  Date = 'Date',
  Boolean = 'Boolean',
}

export const filterableFieldType = (
  field: AtLeast<
    IntegrationField,
    'integrationFieldId' | 'optionsAvailable' | 'fieldType' | 'fieldDataType'
  >,
): IntegrationFieldType | null => {
  if (field.integrationFieldId === 'issuetype') {
    return IntegrationFieldType.IssueType;
  }

  if (field.integrationFieldId === 'description') {
    return IntegrationFieldType.Description;
  }

  if (field.integrationFieldId === 'summary') {
    return IntegrationFieldType.Summary;
  }

  switch (field.optionsAvailable ? field.fieldType : field.fieldDataType) {
    case 'NUMBER':
      return IntegrationFieldType.Number;
    case 'TEXT':
      return IntegrationFieldType.Text;
    case 'DATE':
      return IntegrationFieldType.Date;
    case 'SINGLE_SELECT':
      return IntegrationFieldType.SingleSelect;
    case 'MULTI_SELECT':
      return IntegrationFieldType.MultiSelect;
    case 'BOOLEAN':
      return IntegrationFieldType.Boolean;
    case 'MULTI_LINE_TEXT':
      return IntegrationFieldType.TextArea;
    default:
      return null;
  }
};
